import {useEffect, useRef, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {SERVICE_ENDPOINTS} from "../../../config/config";
import axios from "axios";
import {useDataContext} from "../../../context/DataContext";
import locales from "../../../assets/const/locales";
import startPageEnglish from "../../../mock/lang/startPageEnglish.json";
import startPageGreek from "../../../mock/lang/startPageGreek.json";

export default function useStartPage () {
    const [taxId , setTaxId] = useState(null);
    const navigate = useNavigate();
    const [eligible, setEligible] = useState(true);
    const [visible , setVisible] = useState(true);
    const [errorInput , setErrorInput] = useState(false);
    const {fetchData,data} = useDataContext();
    const [style, setStyle] = useState('block');
    const [searchParams] = useSearchParams();
    const [clicked , setClicked] = useState(false);
    const [openStates, setOpenStates] = useState({});
    const refs = useRef({});
    const [tries, setTries] = useState(data?.tries);

    const [htmlObject, setHtmlObject] = useState(null);

    const lang = (searchParams.get("lang")?.toLowerCase() === locales.ENGLISH) ? locales.ENGLISH : locales.GREEK;
    const translations = lang === "en" ? startPageEnglish : startPageGreek;

    const [errorMessage1, setErrorMessage1] = useState("");
    const [errorMessage2, setErrorMessage2] = useState("");

    const store = (searchParams.get("store") !== null);
    const hidePopup = (searchParams.get("hidePopup") !== null);
    const [isKsybError, setIsKsybError] = useState(false);


    const toggle = (key) => (e) => {
        e.preventDefault();
        setOpenStates((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const changeInput = (value) => {
        setTaxId(value.slice(0,9));
    }
    const getHeight = (key) => {
        return openStates[key] && refs.current[key]
            ? refs.current[key].scrollHeight
            : 0;
    };

    const togglePopup = () => {
        setVisible(!visible);
    }
    useEffect(() => {
        if(taxId !== null && taxId.length === 9) {
            setErrorInput(false);
        }
        if (taxId !== null && taxId.length === 9) {
            setTaxId(taxId.slice(0,9));
        }
    }, [taxId])

    const  checkInput = () => {
        if(taxId !== null && taxId.length === 9) {
            setErrorInput(false);
        }
        else {
            setErrorInput(true);
        }
    }


    //-------------------STRAPI CALL----------------------
    const getHtml = () => {
        axios.get(SERVICE_ENDPOINTS.KSYB_GET_HTML.replace('{lang}', lang))
            .then((res)=> {
                setHtmlObject(res?.data?.data?.[0]?.attributes?.reusables?.[0]?.body);
                window.parent.dispatchEvent(new CustomEvent('resizeIframeKsyb', {
                }));
            });
    }

    const containerRef = useRef(null);
    const [htmlContent, setHtmlContent] = useState('');

    useEffect(() => {
        if (!htmlObject) return;
        const decodedHtml = decodeHTMLEntities(htmlObject);
        const parser = new DOMParser();
        const doc = parser.parseFromString(decodedHtml, 'text/html');
        const scripts = Array.from(doc.querySelectorAll('script'));
        scripts.forEach(script => script.remove());
        setHtmlContent(doc.body.innerHTML);
        (async () => {
            try {
                if (!window.jQuery) {
                    await injectScriptsInOrder([
                        { src: 'https://code.jquery.com/jquery-3.6.0.min.js' }
                    ].map(s => {
                        const scriptEl = document.createElement('script');
                        scriptEl.src = s.src;
                        return scriptEl;
                    }));
                }
                const nonJqueryScripts = scripts.filter(s => !(s.src && s.src.includes('jquery')));
                await injectScriptsInOrder(nonJqueryScripts);

            } catch (err) {
                console.error(err);
            }
        })();

    }, [htmlObject]);

    async function injectScriptsInOrder(scripts) {
        for (const script of scripts) {
            await new Promise((resolve, reject) => {
                const newScript = document.createElement('script');
                if (script.src) {
                    newScript.src = new URL(script.src, window.location.href).href;
                } else {
                    newScript.textContent = script.textContent;
                }
                newScript.async = false;
                newScript.onload = () => {
                    console.log(`Loaded script: ${newScript.src || 'inline script'}`);
                    resolve();
                };
                newScript.onerror = () => reject(new Error(`Failed to load script: ${newScript.src || 'inline script'}`));
                document.body.appendChild(newScript);
            });
        }
    }

    const decodeHTMLEntities= (str) => {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        return textarea.value;
    }

    useEffect(()=> {
        getHtml();
    },[]);

    //------------------ AFM CHECK---------------------------------
    const checkTaxId = () => {
        if(!errorInput) {
            setClicked(true);
            axios.get(`${SERVICE_ENDPOINTS.KSYB_CHECK_TAX_ID}?taxId=`+ taxId,{
            }).then((res) => {

                    if(res?.data?.eligible === true){
                        setStyle("none");
                        fetchData({
                            taxId:taxId
                        })
                        setTimeout(() => {
                            navigate(`/ksyb/selectOptions?lang=${lang === "el" ? "gr" : lang  }&${store ? "store" : ""}`);
                        }, 3000);}
                    else {
                        handleErrorMessage(res?.data?.errorCode);
                        setStyle("none");
                        setEligible(false);
                        setTries(tries + 1);
                        fetchData({
                            tries: tries + 1
                        })
                    }
                }
            ).catch((error) => {
                console.error("Error fetching states ", error);
                setStyle("none");
                setEligible(false);
                setTaxId("");
                handleErrorMessage();
                setTries(tries + 1);
                fetchData({
                    tries: tries + 1
                })

            });
        }
    }
    useEffect(()=> {
        if (tries === 3 && hidePopup !== true){
            setTimeout(() => {
                setTries(0);
                fetchData({
                    tries:0
                })
                window.parent.location.href ="/static/business/{lang}/ela-sthn-cosmote-business".replace('{lang}',lang);
            }, 5000);
            setErrorMessage1("Ginetai anakateythinsi");
            setErrorMessage2(translations["errorMessageKSYB2"]);
        }
    },[tries])

    const handleErrorMessage = (errorCode) => {
        switch (errorCode) {
            case "GEMI001":
                setErrorMessage1(translations["errorMessageGemi1"]);
                setErrorMessage2(translations["errorMessageGemi2"]);
                break;
            case "KSYB002" :
                setIsKsybError(true);
                setTimeout(() => {
                    window.parent.location.href ="/static/business/{lang}/ela-sthn-cosmote-business".replace('{lang}',lang);
                }, 5000);
                break;
            default :
                setErrorMessage1(translations["errorMessageGemi1"]);
                setErrorMessage2(translations["errorMessageGemi2"]);
                break;
        }
    }

    return{setTaxId,taxId,changeInput,checkTaxId,isKsybError,eligible,errorInput,togglePopup,tries,checkInput,containerRef,htmlObject,lang,hidePopup,errorMessage1,errorMessage2, visible,style,translations,clicked, refs, toggle, openStates}
}
